<template>
  <div class="page-shell page-shell--store-settings">
    <section class="page-shell__content" v-permit="'Market.MarketSetting'">
      <div class="page-shell__panel page-shell__tabs page-shell__tabs--store-settings">
        <el-tabs v-model="activeName" class="customTabs" type="border-card" >
      <el-tab-pane label="基础信息" name="detail">
        <div class="forms-containers forms-containers--flat">
          <el-alert
            v-if="marketEdit.closeStatus"
            style="margin-bottom: 16px;"
            type="warning"
            title="商店已关闭，请联系平台客服"
          ></el-alert>
          <el-form ref="form" :model="marketEdit" label-width="120px" :rules="rules">
            <el-row>
              <el-col :span="8">
                <el-form-item prop="name" label="商店名称">
                  <el-input v-model="marketEdit.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item prop="description" label="商店说明">
                  <el-input type="textarea" v-model="marketEdit.description"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item prop="keywords" label="商店关键词">
                  <el-input v-model="marketEdit.keywords"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col  :span="8">
                <el-form-item prop="contactName" label="联系人">
                  <el-input v-model="marketEdit.contactName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item prop="contactPhone" label="联系方式">
                  <el-input v-model="marketEdit.contactPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item prop="portalURL" label="门户地址">
                  <el-input v-model="marketEdit.portalURL" placeholder="请输入门户网站地址"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item class="marketlogo" prop="logo" label="商店LOGO">
                  <el-upload
                    v-loading="uploadImageLoading"
                    class="avatar-uploader"
                    :action="uploadConfig.api"
                    :with-credentials="true"
                    :headers="uploadConfig.headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :on-error="handleAvatarError"
                    :before-upload="beforeAvatarUpload"
                  >
                    <el-avatar
                      class="logoImage"
                      v-loading="uploadImageLoading"
                      v-if="marketEdit.logo && marketEdit.logo.length>0"
                      shape="square"
                      fit="fill"
                      :src="marketEdit.logo"
                    ></el-avatar>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <span style="color: #999999; font-size: 12px;">请上传 150*50 规格的PNG图片</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-button type="primary" style="margin-left: 120px;" @click="updateMarket">提交更新</el-button>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="商店轮播图" name="banner">
        <div class="forms-containers forms-containers--flat">
          <BannerManage />
        </div>
      </el-tab-pane>
      <el-tab-pane label="镜像仓库存储" name="imagehub">
        <div class="forms-containers forms-containers--flat">
          <el-form ref="registryform" :model="registry" label-width="120px" :rules="registryrules">
            <el-row>
              <el-col :span="8">
                <el-form-item prop="mode" label="提供方">
                  <el-radio-group @change="changeMode" v-model="registryMode">
                    <el-radio label="1">平台提供</el-radio>
                    <el-radio label="2">自定义</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="customRegistry">
              <el-col :span="8">
                <el-form-item prop="hubURL" label="镜像仓库地址">
                  <el-input v-model="registry.hubURL"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="customRegistry">
              <el-col :span="8">
                <el-form-item prop="namespace" label="命名空间">
                  <el-input v-model="registry.namespace"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="customRegistry">
              <el-col :span="8">
                <el-form-item prop="hubUser" label="用户名">
                  <el-input v-model="registry.hubUser"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="customRegistry">
              <el-col :span="8">
                <el-form-item prop="hubPassword" label="密码">
                  <el-input type="password" v-model="registry.hubPassword" show-password></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-button type="primary" style="margin-left: 120px;" @click="updateRegistry">提交</el-button>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="支付配置" name="payment">
        <div class="forms-containers forms-containers--flat">
          <el-form ref="paymentform" :model="paymentConfig" label-width="180px" :rules="paymentrules">
            <el-row>
              <el-col :span="12">
                <el-form-item prop="appID" label="微信APPID">
                  <el-input v-model="paymentConfig.appID" placeholder="请输入微信应用ID"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="mchID" label="微信商户号">
                  <el-input v-model="paymentConfig.mchID" placeholder="请输入微信商户号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="mchAPIv3Key" label="微信API V3密钥">
                  <el-input type="password" v-model="paymentConfig.mchAPIv3Key" show-password placeholder="请输入微信API V3密钥(32位)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="mchCertSerialNo" label="商户证书序列号">
                  <el-input v-model="paymentConfig.mchCertSerialNo" placeholder="请输入商户证书序列号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="privateKeyPath" label="商户私钥路径">
                  <el-input v-model="paymentConfig.privateKeyPath" placeholder="请输入商户私钥文件路径"></el-input>
                  <el-upload
                    action="#"
                    :show-file-list="false"
                    :before-upload="beforePaymentPrivateKeyUpload"
                    :http-request="uploadPaymentPrivateKeyFile"
                  >
                    <el-button
                      size="small"
                      style="margin-top: 8px;"
                      :loading="paymentPrivateKeyUploading"
                    >上传私钥文件(.pem)</el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="notifyURL" label="支付回调通知地址">
                  <el-input v-model="paymentConfig.notifyURL" placeholder="请输入支付回调通知地址"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-button type="primary" style="margin-left: 180px;" @click="updatePaymentConfig">提交</el-button>
              <el-button type="danger" plain :loading="paymentDeleteLoading" @click="removePaymentConfig">删除配置</el-button>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="企业设置" name="enterprise">
        <div class="forms-containers forms-containers--flat">
          <el-form ref="internalConfigForm" :model="internalConfig" label-width="180px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="内部 API 令牌">
                  <el-input
                    v-model="internalConfig.internalApiToken"
                    type="password"
                    show-password
                    placeholder="请输入内部 API Token"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="内部域名">
                  <el-input
                    v-model="internalConfig.internalDomain"
                    placeholder="请输入内部域名"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="内部企业 ID">
                  <el-input
                    v-model="internalConfig.internalEnterpriseID"
                    placeholder="请输入内部企业 ID"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-button type="primary" style="margin-left: 180px;" @click="updateInternalConfig">保存</el-button>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
      </div>
    </section>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import {
  getMarketInfo,
  putMarketInfo,
  putMarketRegistryInfo,
  getMarketRegistryInfo
} from '@/api/appStore';
import {
  getPaymentConfig,
  putPaymentConfig,
  uploadPaymentPrivateKey,
  deletePaymentConfig,
  getMarketInternalConfig as getMarketInternalConfigApi,
  putMarketInternalConfig as putMarketInternalConfigApi
} from '@/api/stores';
import { errorHandle } from '@/utils/error';
import { havePerm } from '@/utils/auth';
import BannerManage from '@/components/BannerManage/index';
export default {
  name: 'StoreSettings',
  created() {
    if (havePerm('Market.MarketSetting')) {
      this.getMarketInfo();
      this.getMarketRegistryInfo();
      this.getPaymentConfig();
      this.getMarketInternalConfig();
    }
  },
  components: { BannerManage },
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      uploadImageLoading: false,
      activeName: 'detail',
      customRegistry: false,
      marketEdit: {},
      registry: {},
      oldRegistry: null,
      registryMode: '1',
      paymentConfig: {
        appID: '',
        mchID: '',
        mchAPIv3Key: '',
        mchCertSerialNo: '',
        privateKeyPath: '',
        notifyURL: ''
      },
      paymentPrivateKeyUploading: false,
      paymentDeleteLoading: false,
      internalConfig: {
        internalApiToken: '',
        internalDomain: '',
        internalEnterpriseID: ''
      },
      originalInternalConfig: {
        internalApiToken: '',
        internalDomain: '',
        internalEnterpriseID: ''
      },
      rules: {
        name: [
          {
            required: true,
            min: 2,
            max: 12,
            message: '商店名称建议2-12个字符',
            trigger: 'blur'
          }
        ],
        contactName: [
          { required: true, message: '联系人是必填', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '联系人名称字符在2-20之间',
            trigger: 'blur'
          }
        ],
        contactPhone: [
          { required: true, message: '联系电话是必填', trigger: 'blur' },
          { min: 7, max: 12, message: '联系电话只能是7-12位，由数字和-组成', trigger: 'blur' },
          {
            pattern: /^[0-9-]+$/,
            message: '联系电话只能是7-12位，由数字和-组成',
            trigger: 'blur'
          }
        ],
        description: [
          {
            max: 255,
            message: '商店简介字符数在255以内',
            trigger: 'blur'
          }
        ],
        portalURL: [
          {
            pattern: /^https?:\/\/[\w.-]+(:\d+)?(\/\S*)?$/,
            message: '请输入正确的URL格式',
            trigger: 'blur'
          }
        ]
      },
      registryrules: {
        hubUrl: {
          required: true,
          min: 2,
          max: 255,
          message: '镜像仓库地址不符合规范',
          trigger: 'blur'
        },
        namespace: {
          max: 255,
          message: '镜像仓库地址不符合规范',
          trigger: 'blur'
        },
        hubUser: {
          max: 255,
          message: '镜像仓库地址不符合规范',
          trigger: 'blur'
        },
        hubPassword: {
          max: 255,
          message: '镜像仓库地址不符合规范',
          trigger: 'blur'
        }
      },
      paymentrules: {
        appID: [
          {
            required: true,
            message: '请输入微信APPID',
            trigger: 'blur'
          },
          {
            max: 100,
            message: '微信APPID长度不能超过100个字符',
            trigger: 'blur'
          }
        ],
        mchID: [
          {
            required: true,
            message: '请输入微信商户号',
            trigger: 'blur'
          },
          {
            max: 100,
            message: '微信商户号长度不能超过100个字符',
            trigger: 'blur'
          }
        ],
        mchAPIv3Key: [
          {
            required: true,
            message: '请输入微信API V3密钥',
            trigger: 'blur'
          },
          {
            len: 32,
            message: 'API V3密钥必须是32位字符',
            trigger: 'blur'
          }
        ],
        mchCertSerialNo: [
          {
            required: true,
            message: '请输入商户证书序列号',
            trigger: 'blur'
          },
          {
            max: 255,
            message: '商户证书序列号长度不能超过255个字符',
            trigger: 'blur'
          }
        ],
        privateKeyPath: [
          {
            required: true,
            message: '请输入商户私钥路径',
            trigger: 'blur'
          },
          {
            max: 500,
            message: '商户私钥路径长度不能超过500个字符',
            trigger: 'blur'
          }
        ],
        notifyURL: [
          {
            required: true,
            message: '请输入支付回调通知地址',
            trigger: 'blur'
          },
          {
            type: 'url',
            message: '请输入正确的URL格式',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    }
  },
  methods: {
    changeMode(mode) {
      if (mode == '2') {
        this.customRegistry = true;
      } else {
        this.customRegistry = false;
      }
    },
    getMarketInfo() {
      getMarketInfo({ marketID: this.marketID }).then((re) => {
        if (re) {
          this.marketEdit = re;
        }
      });
    },
    getMarketRegistryInfo() {
      getMarketRegistryInfo({ marketID: this.marketID }).then((re) => {
        if (re && re.hubURL) {
          this.registry = re;
          this.oldRegistry = Object.assign({}, re);
          if (re.default) {
            this.registryMode = '2';
            this.customRegistry = true;
            return;
          }
        }
        this.registryMode = '1';
      });
    },
    updateMarket() {
      const formName = 'form';
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.marketEdit.marketID = this.marketID;
          putMarketInfo(this.marketEdit)
            .then((re) => {
              this.$store.dispatch('GetMarketDetail', {
                marketID: this.marketID
              });
              this.$message.success('更新成功');
            })
            .catch((err) => {
              errorHandle(err);
            });
        }
      });
    },
    updateRegistry() {
      const formName = 'registryform';
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.registryMode == '2') {
            this.registry.default = true;
          } else if (this.oldRegistry) {
            this.registry = this.oldRegistry;
            this.registry.default = false;
          } else {
            this.$message.success('无需修改');
            return;
          }
          this.registry.marketID = this.marketID;
          putMarketRegistryInfo(this.registry)
            .then((re) => {
              this.$message.success('更新成功');
            })
            .catch((err) => {
              errorHandle(err);
            });
        }
      });
    },
    getDefaultPaymentConfig() {
      return {
        appID: '',
        mchID: '',
        mchAPIv3Key: '',
        mchCertSerialNo: '',
        privateKeyPath: '',
        notifyURL: ''
      };
    },
    buildPaymentConfigPayload() {
      return {
        appID: this.paymentConfig.appID,
        mchID: this.paymentConfig.mchID,
        mchAPIv3Key: this.paymentConfig.mchAPIv3Key,
        mchCertSerialNo: this.paymentConfig.mchCertSerialNo,
        privateKeyPath: this.paymentConfig.privateKeyPath,
        notifyURL: this.paymentConfig.notifyURL
      };
    },
    getPaymentConfig() {
      getPaymentConfig({ marketID: this.marketID }).then((re) => {
        if (re) {
          this.paymentConfig = Object.assign(this.getDefaultPaymentConfig(), re);
        }
      }).catch((err) => {
        if (err && err.code === 404) {
          this.paymentConfig = this.getDefaultPaymentConfig();
          return;
        }
        errorHandle(err);
      });
    },
    beforePaymentPrivateKeyUpload(file) {
      if (!file || !file.name) {
        this.$message.error('文件无效，请重新选择');
        return false;
      }
      if (!/\.pem$/i.test(file.name)) {
        this.$message.error('仅支持上传 .pem 私钥文件');
        return false;
      }
      if (file.size <= 0) {
        this.$message.error('私钥文件不能为空');
        return false;
      }
      return true;
    },
    uploadPaymentPrivateKeyFile(fileOption) {
      this.paymentPrivateKeyUploading = true;
      uploadPaymentPrivateKey({
        marketID: this.marketID,
        file: fileOption.file
      }).then((re) => {
        if (re && re.privateKeyPath) {
          this.paymentConfig.privateKeyPath = re.privateKeyPath;
        }
        this.$message.success('私钥上传成功');
      }).catch((err) => {
        errorHandle(err);
      }).finally(() => {
        this.paymentPrivateKeyUploading = false;
      });
    },
    removePaymentConfig() {
      this.$confirm('确认删除当前商店微信支付配置吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.paymentDeleteLoading = true;
        deletePaymentConfig({ marketID: this.marketID })
          .then(() => {
            this.paymentConfig = this.getDefaultPaymentConfig();
            this.$message.success('支付配置删除成功');
          })
          .catch((err) => {
            errorHandle(err);
          })
          .finally(() => {
            this.paymentDeleteLoading = false;
          });
      }).catch(() => {});
    },
    getMarketInternalConfig() {
      getMarketInternalConfigApi({ marketID: this.marketID }).then((re) => {
        this.applyInternalConfigFromResponse(re || {});
      }).catch((err) => {
        errorHandle(err);
      });
    },
    applyInternalConfigFromResponse(re = {}) {
      const latestConfig = {
        internalApiToken: this.normalizeInternalConfigValue(re.internalApiToken),
        internalDomain: this.normalizeInternalConfigValue(re.internalDomain),
        internalEnterpriseID: this.normalizeInternalConfigValue(
          re.internalEnterpriseID
        )
      };
      this.internalConfig = Object.assign({}, latestConfig);
      this.originalInternalConfig = Object.assign({}, latestConfig);
    },
    normalizeInternalConfigValue(value) {
      if (value === null || value === undefined) {
        return '';
      }
      return String(value);
    },
    updateInternalConfig() {
      const payload = {};
      const keys = ['internalApiToken', 'internalDomain', 'internalEnterpriseID'];
      keys.forEach((key) => {
        const newValue = this.normalizeInternalConfigValue(this.internalConfig[key]);
        const oldValue = this.normalizeInternalConfigValue(this.originalInternalConfig[key]);
        if (newValue !== oldValue) {
          payload[key] = newValue === '' ? null : newValue;
        }
      });
      if (!Object.keys(payload).length) {
        this.$message.info('未检测到配置变更');
        return;
      }
      putMarketInternalConfigApi(
        Object.assign(
          {
            marketID: this.marketID
          },
          payload
        )
      ).then((re) => {
        this.applyInternalConfigFromResponse(re || {});
        this.$message.success('企业设置保存成功');
      }).catch((err) => {
        errorHandle(err);
      });
    },
    updatePaymentConfig() {
      const formName = 'paymentform';
      this.$refs[formName].validate((valid) => {
        if (valid) {
          putPaymentConfig({
            marketID: this.marketID,
            ...this.buildPaymentConfigPayload()
          })
            .then((re) => {
              if (re) {
                this.paymentConfig = Object.assign(this.getDefaultPaymentConfig(), re);
              }
              this.$message.success('支付配置保存成功');
            })
            .catch((err) => {
              errorHandle(err);
            });
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.marketEdit.logo = res.FileURL;
      this.uploadImageLoading = false;
    },
    handleAvatarError(re) {
      if (re.code == 10024) {
        this.$message.error(
          '上传图片类型不支持，请上传以.png .jpg .jpeg 结尾的图片'
        );
        return;
      }
      this.$message.error('上传失败!');
      this.uploadImageLoading = false;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.error('上传头像图片只能是 JPG、PNG格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      const canUpload = (isJPG || isPng) && isLt2M;
      if (canUpload) {
        this.uploadImageLoading = true;
      }
      return canUpload;
    },
    beforeAvatarUploadpic(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        return this.$message.error('上传图片只能是 JPG、PNG格式!');
      }
      if (!isLt2M) {
        return this.$message.error('上传图片大小不能超过 2MB!');
      }

      return (isJPG || isPng) && isLt2M;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/styles/page-shell.scss';

.page-shell--store-settings {
  .page-shell__content {
    gap: 0;
  }

  .page-shell__tabs--store-settings {
    padding: 18px 20px 20px;
  }
}

.avatar-uploader {
  width: 150px;
  height: 50px;
  border-radius: 10px;
  border: 2px dashed #f0f0f0;
}
::v-deep .avatar-uploader .el-upload {
  line-height: 50px;
  width: 150px;
}
.logoImage {
  width: 150px;
  height: 50px;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/storeManage/storeSettings/index.vue